import {
  DOCUMENT,
  IMAGE_CONFIG,
  IMAGE_LOADER,
  type ImageLoaderConfig,
  PRECONNECT_CHECK_BLOCKLIST,
} from '@angular/common';
import { inject, type Provider } from '@angular/core';

import { ALLOWED_WIDTHS } from '@cibule/image';

const PLACEHOLDER_QUALITY = 20;

const isSvg = (src: string): boolean => {
  const pathname = src.split(/[?#]/)[0] ?? src;
  return pathname.toLowerCase().endsWith('.svg');
};

const aryaImageLoader = (config: ImageLoaderConfig): string => {
  if (!config.width || isSvg(config.src)) return config.src;

  const separator = config.src.includes('?') ? '&' : '?';

  const requested = config.width;

  if (config.isPlaceholder) {
    return `${config.src}${separator}w=${requested}&q=${PLACEHOLDER_QUALITY}`;
  }

  const width = ALLOWED_WIDTHS.find((w) => w >= requested) ?? ALLOWED_WIDTHS.at(-1) ?? requested;
  return `${config.src}${separator}w=${width}`;
};

export const provideImageOptimization = (): Provider[] => [
  { provide: IMAGE_LOADER, useValue: aryaImageLoader },
  {
    provide: IMAGE_CONFIG,
    useValue: {
      breakpoints: [...ALLOWED_WIDTHS],
      placeholderResolution: 30,
    },
  },
  { provide: PRECONNECT_CHECK_BLOCKLIST, useFactory: () => inject(DOCUMENT).location.hostname },
];
